import { motion } from "framer-motion";
import {
  BarChart3,
  ShieldCheck,
  Layers,
} from "lucide-react";

import Section from "@/components/layout/Section";
import Container from "@/components/layout/Container";

const items = [
  {
    title: "MARKET BACKED SIGNALS",
    text: "Estimates reflect comparable listings and demand patterns.",
    icon: BarChart3,
  },
  {
    title: "EXECUTION AWARE MODELLING",
    text: "Seasonality and operational friction are considered.",
    icon: Layers,
  },
  {
    title: "NO ARTIFICIAL UPSIDE",
    text: "No inflated projections or unrealistic promises.",
    icon: ShieldCheck,
  },
  {
    title: "DATA RANGE CALIBRATION",
    text: "Outputs reflect a range of outcomes, not a single value.",
    icon: BarChart3,
  },
  {
    title: "LOCAL DEMAND SENSITIVITY",
    text: "Estimates adapt to local supply and demand.",
    icon: Layers,
  },
  {
    title: "CONSERVATIVE MODELLING",
    text: "Assumptions prioritise realistic performance.",
    icon: ShieldCheck,
  },
];

const columns = [
  items.filter((_, i) => i % 2 === 0),
  items.filter((_, i) => i % 2 !== 0),
];

export default function CalculatorTrustStrip() {

  return (

    <Section background="bg-bg-light" padding="lg">

      <Container>

        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 items-center">

          {/* LEFT */}
          <div className="max-w-[420px]">

            <span className="text-small font-semibold uppercase tracking-wide text-text-muted">
              Estimate methodology
            </span>

            <h3 className="mt-5 text-display font-extrabold text-text-primary">
              Built on disciplined modelling
            </h3>

            <p className="mt-6 text-body text-text-muted leading-relaxed">
              Every estimate reflects structured assumptions, real data and
              conservative projections designed to avoid inflated outcomes.
            </p>

          </div>

          {/* RIGHT FLOW */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 h-[420px] overflow-hidden">

            {columns.map((col, colIndex) => {

              const repeated = [...col, ...col, ...col];

              return (
                <motion.div
                  key={colIndex}
                  className="flex flex-col gap-5"
                  animate={{ y: ["0%", "-50%"] }}
                  transition={{
                    duration: 20 + colIndex * 4,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                >

                  {repeated.map((item, i) => {

                    const Icon = item.icon;

                    return (
                      <div
                        key={i}
                        className="
                          relative rounded-xl
                          border border-border-soft
                          bg-bg-surface p-4
                        "
                      >

                        {/* DARK STRIP */}
                        <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-brand-secondary opacity-60" />

                        {/* LIVE DOT */}
                        <div className="absolute top-3 right-3 w-2 h-2 rounded-full bg-brand-secondary opacity-70 animate-pulse" />

                        <div className="flex items-start gap-3">

                          <div className="
                            w-9 h-9 rounded-lg flex items-center justify-center
                            bg-bg-light border border-border-soft
                          ">
                            <Icon size={16} className="text-text-primary" />
                          </div>

                          <div>
                            <div className="text-[12px] font-semibold text-text-primary tracking-wide">
                              {item.title}
                            </div>

                            <p className="text-[13px] text-text-muted mt-1 leading-relaxed">
                              {item.text}
                            </p>
                          </div>

                        </div>

                      </div>
                    );

                  })}

                </motion.div>
              );

            })}

          </div>

        </div>

      </Container>

    </Section>
  );
}